import { render } from "./VendorNoteTagsField.vue?vue&type=template&id=7b9c4869"
import script from "./VendorNoteTagsField.vue?vue&type=script&lang=js"
export * from "./VendorNoteTagsField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__